import { createSlice } from "@reduxjs/toolkit";

export const appSpinnerSlice = createSlice({
  name: "appSpinner",
  initialState: {
    isShown: false
  },
  reducers: {
    showAppSpinner: state => {
      state.isShown = true;
    },
    hideAppSpinner: state => {
      state.isShown = false;
    }
  }
});

export const { showAppSpinner, hideAppSpinner } = appSpinnerSlice.actions;

export default appSpinnerSlice.reducer;